import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {map, Observable} from 'rxjs';
import {AuthService} from '@auth0/auth0-angular';
import {AccessManagementService} from '../services/access-management.service';
import {environment} from 'src/environments/environment';
import {AUTH0_USER_ROLES_KEY} from '../shared/utils/constants';

@Injectable({
  providedIn: 'root',
})
export class PermissionsGuard  {
  constructor(
    private access: AccessManagementService,
    private auth: AuthService,
    private router: Router
  ) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    if (
      this.access.userPermissions.length &&
      this.access.checkPermissions(route.data['permission'])
    ) {
      return true;
    }
    return this.auth.user$.pipe(
      map(user => {
        const userPermissions = user![AUTH0_USER_ROLES_KEY];
        if (
          userPermissions.length === 0 ||
          (userPermissions.includes('Employee') && userPermissions.length === 1)
        ) {
          window.location.href = environment.timeTrackingTool;
          return false;
        }
        if (this.access.checkPermissions(route.data['permission'])) {
          return true;
        } else {
          this.router.navigate(['']);
          return false;
        }
      })
    );
  }
}
